/**
 * Shared constants for tender detail components
 */

export const STATUS_OPTIONS = ['Active', 'Submitted', 'Won', 'Lost', 'Archived', 'Void'];
export const ENQUIRY_STATUS_OPTIONS = ['Pending', 'Received', 'No Response'];
export const PLANNING_STATUS_OPTIONS = ['Approved', 'In Process', 'Exploring Options'];
export const PROJECT_TYPE_OPTIONS = ['Extension', 'Loft Conversion', 'Garden Room', 'Garage Conversion', 'Refurb', 'New Build', 'Insurance', 'Other'];
export const TENDER_TYPE_OPTIONS = [
  { value: 'DEV', label: 'Development' },
  { value: 'CON', label: 'Construction' }
];
export const BUDGET_RANGE_OPTIONS = ['£10k - £20k', '£20k - £50k', '£50k - £80k', '£80k - £150k', '£150k+'];
export const START_DATE_OPTIONS = ['1-2 months', '2-6 months', '6-12 months'];
export const TRADE_OPTIONS = ['Ground Worker', 'Bricklayer', 'Carpenter', 'Roofer', 'Plasterer', 'Decorator', 'Plumber', 'Electrician', 'Other'];
export const FEEDBACK_STATUS_OPTIONS = ['Not Sent', 'Sent', 'Response Received'];
export const LOSS_REASON_OPTIONS = ['Price', 'Timing', 'Scope', 'Competition', 'Client Changed Mind', 'Project Cancelled', 'Other'];

export const STATUS_COLORS = {
  'Active': 'bg-blue-500/20 text-blue-400 border-blue-500/30',
  'Submitted': 'bg-purple-500/20 text-purple-400 border-purple-500/30',
  'Won': 'bg-green-500/20 text-green-400 border-green-500/30',
  'Lost': 'bg-red-500/20 text-red-400 border-red-500/30',
  'Archived': 'bg-gray-500/20 text-gray-400 border-gray-500/30',
  'Void': 'bg-gray-500/20 text-gray-400 border-gray-500/30'
};

export const formatCurrency = (value) => {
  if (!value && value !== 0) return '-';
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value);
};
